import { Link, useLocation, useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import {
  CalendarIcon,
  FerrisWheelIcon,
  HelpCircleIcon,
  ImagesIcon,
  LifeBuoyIcon,
  MenuIcon,
  PalmtreeIcon,
  PhoneIcon,
  ShipIcon,
  UsersIcon,
  type LucideIcon,
} from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "./ui/button";
import { cn } from "@/lib/utils";
import { useState } from "react";

interface NavLinksProps {
  title: string;
  link: string;
  icon: LucideIcon;
}

interface HeaderNavLink {
  link: string;
  label: string;
}

export const navLinks: NavLinksProps[] = [
  {
    title: "Home",
    link: "/",
    icon: CalendarIcon,
  },
  {
    title: "Prenota un'escursione",
    link: "/checkout",
    icon: PalmtreeIcon,
  },
  {
    title: "Noleggia un'imbarcazione",
    link: "/rental",
    icon: FerrisWheelIcon,
  },
  {
    title: "Flotta",
    link: "/boats",
    icon: ShipIcon,
  },
  {
    title: "Tour",
    link: "/tours",
    icon: LifeBuoyIcon,
  },
  {
    title: "Gallery",
    link: "/gallery",
    icon: ImagesIcon,
  },
  {
    title: "Contatti",
    link: "/contact",
    icon: PhoneIcon,
  },
  {
    title: "Chi siamo",
    link: "/about",
    icon: UsersIcon,
  },
  {
    title: "Faq",
    link: "/faq",
    icon: HelpCircleIcon,
  },
];

const headerNavItems: HeaderNavLink[] = [
  {
    label: "Prenota",
    link: "/checkout",
  },
  {
    label: "Noleggia",
    link: "/rental",
  },
  {
    label: "Tremiti",
    link: "/tours/tremiti",
  },
  {
    label: "Croazia",
    link: "/tours/croazia",
  },
  {
    label: "Gargano",
    link: "/tours/costa",
  },
  {
    label: "Flotta",
    link: "/boats",
  },
  {
    label: "Gallery",
    link: "/gallery",
  },
];

const MainLogo = (): JSX.Element => {
  {
    /*    <img
      alt=""
      src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMTMuMSIgaGVpZ2h0PSI1MC4xIiB2aWV3Qm94PSIwIDAgMjEzLjEgNTAuMSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnZlcmdhIG5hbWUgb25seSB3aGl0ZTwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik0zMS41LDY3LjhhMi4xLDIuMSwwLDAsMS0xLjYuOEgxMy4zYy0uOSwwLTEuMi0uMy0xLjMtMS4yLS41LTQuMy0uOS04LjUtMS40LTEyLjhzLS43LTYuNS0xLjEtOS43TDgsMzEuNWMtLjItMi4xLS40LTQuMi0uNy02LjJhNiw2LDAsMCwwLS42LTEuOWMtLjYtMS4xLTEuMy0yLjEtMi0zLjJWMjBhMS42LDEuNiwwLDAsMSwuOS0uM0gyMi4xYy45LDAsMS4xLjEsMS4yLDFzLjMsMi45LjQsNC40Yy4zLDMuMi41LDYuMy44LDkuNHMuMywzLjUuNCw1LjIuNSw2LjIuOCw5LjMuNSw2LjYuOCw5LjljMCwxLC4xLDIsLjIsMy4xcy4xLjQuMi42bC41LS41LDcuNS0xMi41YzMuNS01LjcsNy0xMS40LDEwLjQtMTcuMmExOS44LDE5LjgsMCwwLDEsOC4yLTcuNSw0OS42LDQ5LjYsMCwwLDEsMTMtNC4zLDc1LjUsNzUuNSwwLDAsMSwxNy44LTEuMiwxMDcuNCwxMDcuNCwwLDAsMSwxMi42LDEuMmM2LjYsMSwxMy4xLDIuMywxOS42LDMuNmwxMC40LDIsOSwxYzIuNC4xLDQuOC4yLDcuMi4xYTY0LjQsNjQuNCwwLDAsMCw4LjctMWM3LTEuMywxMy42LTMuOCwyMC4yLTYuNSwxLjItLjUsMi41LS44LDMuNy0xLjJoLjVsLS4zLjRjLTEuMywxLjEtMi40LDIuMi0zLjgsMy4yYTY0LjIsNjQuMiwwLDAsMS0yMi4yLDkuNCw2NC4xLDY0LjEsMCwwLDEtMTMuMSwxLjRjLTMuNSwwLTcsMC0xMC41LS4zYTExMi44LDExMi44LDAsMCwxLTE3LjQtMi45bC05LjgtMi41cS02LjktMS42LTEzLjgtM2E1NS42LDU1LjYsMCwwLDAtMTAuOC0uOSwzNC4xLDM0LjEsMCwwLDAtMTEuOSwxLjksMjIuMywyMi4zLDAsMCwwLTExLjUsOS45Yy0xLjgsMy4xLTMuOCw2LjItNS42LDkuM0M0MS43LDUwLjYsMzgsNTYuOCwzNC4zLDYzQTE0LjgsMTQuOCwwLDAsMSwzMyw2NS4xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNC43IC0xOC41KSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNMTExLjMsNjguNWMtMS4yLDAtMS4zLS4xLTEuNy0xLjJzLTEuNi00LjQtMi4zLTYuNy0uNy0xLjEtMS41LTEuMS0xLjEuNi0xLjIsMS4ybC0xLjcsNi41Yy0uMywxLjEtLjUsMS4yLTEuNiwxLjJIODguOGMtMS4xLDAtMS4zLS4yLTEtMS4zLDIuNC05LjEsNC45LTE4LjIsNy4zLTI3LjNhMiwyLDAsMCwwLS42LTIuM2wtMS4yLTEuMy0uMy0uNi43LS4yaDMyLjRhNy4zLDcuMywwLDAsMSwzLjguOCw0LjUsNC41LDAsMCwxLDIuNCw1LjRjLTEsMy45LTIuMSw3LjYtMywxMS41YTcuNyw3LjcsMCwwLDEtNC4yLDQuOGwtMy40LDEuM2MtLjUuMS0uNS4yLS40LjZsMS44LDRjLjUsMS4zLDEuMSwyLjYsMS43LDMuOXMwLC43LS41LjdtLTE0LjgtMTJoM2EuOS45LDAsMCwwLDEtLjdjLjctMi41LDEuNS01LDIuMi03LjUuMi0xLC41LTIsLjctM2wxLjUtNS44YzAtLjMsMC0uNy0uMS0uN2EyLjMsMi4zLDAsMCwwLTEuMS0uM2gtLjljLTEuNC4xLTIuOCwwLTQuMiwwcy0xLjIuMy0xLjQsMUwxMDYsNTUuNWMtLjIuNywwLC45LjYuOUEyOCwyOCwwLDAsMCwxMDkuNSw1Ni40WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuNyAtMTguNSkiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTE0NS4yLDY0LjRjLS4xLjQtLjIuOC4xLDFsLjQuMmg2YTEuMiwxLjIsMCwwLDAsMS0uOWwyLjEtNy43YTEuMSwxLjEsMCwwLDAtLjMtLjgsMTcuMSwxNy4xLDAsMCwwLTEuOC0yYy0uMS0uMi0uMi0uMy0uMi0uNWguNWMuMS0uMS4yLS4xLjQsMGgxNi41YS43LjcsMCwwLDEsLjcuNWMwLC4xLS4xLjItLjEuMy0xLjIsNC40LTIuMyw4LjgtMy41LDEzLjNhMS4xLDEuMSwwLDAsMS0xLjIuOEgxMzZhNy4xLDcuMSwwLDAsMS0zLjctMS4yLDQuMiw0LjIsMCwwLDEtMS42LTQuN2w0LjgtMTguNGEyNi44LDI2LjgsMCwwLDAsLjctMi43Yy45LTIuOCwzLTQuNCw1LjYtNS40YTEyLjIsMTIuMiwwLDAsMSwzLjgtLjdoMjIuMmE3LjgsNy44LDAsMCwxLDIuNi40YzIuOS44LDQuMiwzLjEsMy40LDYuMnMtMS4yLDQuOC0xLjksNy4yLS42LDEuMy0xLjcsMS4zSDE1Ny45Yy0xLjEsMC0xLjMtLjItMS4xLTEuMnMxLjEtMy42LDEuNi01LjRsMS4xLTQuMWMuMi0xLDAtMS4zLTEuMS0xLjNoLTUuMWMtLjksMC0xLjIuMi0xLjQsMS4xLTIsNy4zLTMuOSwxNC42LTUuOSwyMS45IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNC43IC0xOC41KSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNMjAwLjksNjguNWgtLjhhMSwxLDAsMCwxLTEuMS0xYy0uNC0xLjQtLjgtMi43LTEuMS00LjFhMS4xLDEuMSwwLDAsMC0xLjEtLjlIMTg0LjVhMS45LDEuOSwwLDAsMC0xLjYuOEwxODEuNyw2NWMtLjIuNS0xLjcsMy0yLjcsM2gtNmMtLjcsMCwxLjctMy42LDItNGw0LjgtNi43LDcuOS0xMSw0LTUuNWEyLjYsMi42LDAsMCwwLC41LTIuNSw4LjMsOC4zLDAsMCwxLS40LTEuNWMtLjItMSwwLTEuMywxLTEuM2gxNy4xYS45LjksMCwwLDEsLjkuOWwzLDEzLjJjMS4yLDUuNSwyLjUsMTEsMy43LDE2LjVsLjMsMS42Yy4xLjUtLjEuOC0uNi44aC01LjhtLTIwLTloNC41Yy44LDAsMS0uMi45LTEtLjgtMy41LTEuNS03LTIuMy0xMC40bC0uMy0uNWMtLjIuMS0uNC4xLS41LjNsLTcuMywxMC43YS42LjYsMCwwLDAtLjIuN2MuMS4yLjUuMi43LjNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNC43IC0xOC41KSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNNDgsNjhsNy43LTI4LjZhMS44LDEuOCwwLDAsMC0uNi0xLjhsLTEuMy0xLjVjLS4yLS4xLS4zLS40LS4yLS41cy4zLS4yLjUtLjJoMzVjMS40LDAsMS42LjMsMS4zLDEuN3MtLjcsMS4zLTEuOSwxLjNINzEuOGExLjIsMS4yLDAsMCwwLTEsLjlMNjguMSw0OS41Yy0uMi42LjEsMSwuOCwxSDg2YTIuNywyLjcsMCwwLDEtLjguN2MtMy43LDIuNS0yLjMsMi4xLTYuOSwyLjFINjguN2MtMS41LDAtMS43LjEtMiwxLjUtLjksMy4xLTEuNyw2LjMtMi41LDkuNC0uMy45LS4xLDEuMi45LDEuMkg4MmwtLjMuNUw3OC44LDY4YTYuNSw2LjUsMCwwLDEtMiwuNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuNyAtMTguNSkiLz48L3N2Zz4="
      loading="eager"
    />*/
  }
  return (
    <img
      className="logo-placeholder"
      src={`/images/logo.avif`}
      alt="Verganautic"
      width={129}
      height={72}
      loading="eager"
    />
  );
};

const Header = (): JSX.Element => {
  const [sideMenuOpen, setSideMenuOpen] = useState<boolean>(false);

  const location = useLocation();
  //const cdn = import.meta.env.VITE_CLOUDFRONT_DOMAIN;

  const navigate = useNavigate();
  const handleNavigate = (link: string) => {
    setSideMenuOpen(!sideMenuOpen);
    navigate(link);
  };

  const slideShowPages = [
    "/",
    "/tours/tremiti",
    "/tours/costa",
    "/tours/croazia",
  ];

  return (
    <div className="absolute top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between p-4">
        <div className="flex items-center">
          <Link to="/">
            <MainLogo />
          </Link>
          <ul className="flex-1 hidden lg:flex lg:items-center gap-6 ml-12 ">
            {headerNavItems.map((item, index) => {
              return (
                <li key={index}>
                  <Link
                    className={cn(
                      "uppercase text-sm font-bold tracking-widest block relative transition-all duration-350 ease-in-out hover:border-b",
                      slideShowPages.includes(location.pathname) &&
                        "text-white border-white",
                      location.pathname === item.link && "border-b",
                    )}
                    to={item.link}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div>
          <Sheet open={sideMenuOpen} onOpenChange={setSideMenuOpen}>
            <SheetTrigger asChild>
              <button
                className={cn(
                  "flex items-center gap-1 focus:ring-2 focus:ring-offset-2 focus:ring-white transition-colors",
                  slideShowPages.includes(location.pathname) && "text-white",
                )}
                aria-label="Apri menu"
              >
                Menù
                <MenuIcon className="size-10" />
              </button>
            </SheetTrigger>
            <SheetContent className="flex flex-col items-center">
              <nav className="flex flex-col items-center gap-6 text-lg font-medium my-auto">
                {navLinks.map((item) => (
                  <button
                    type="button"
                    onClick={() => handleNavigate(item.link)}
                    className="flex items-center gap-2 text-lg font-semibold"
                    key={item.link}
                  >
                    {item.title}
                  </button>
                ))}
              </nav>
              <div className="mt-auto">
                <Card>
                  <CardHeader>
                    <CardTitle>Prenota ora</CardTitle>
                    <CardDescription>
                      Prenota la tua escursione per vivere un&apos;esperienza
                      indimenticabile.
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <Button
                      onClick={() => handleNavigate("/checkout")}
                      className={"w-full"}
                    >
                      Prenota
                    </Button>
                  </CardContent>
                </Card>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </div>
  );
};

export default Header;
